import React, { useContext } from "react";
import { VariantContextData } from "../variants/VariantBuilderContext";
import SchedulerEmbedSettings from "./SchedulerEmbedSettings";
import SchedulerRecommendationSettings from "../scheduler_recommendations/SchedulerRecommendationSettings";
import NewSchedulerRecommendation from "../scheduler_recommendations/NewSchedulerRecommendation";
import Tooltip from "../shared/Tooltip";

const ElementSettingsScheduler = (props) => {
  const [contextData, builder] = useContext(VariantContextData);
  const element = builder.selected().object;
  const variant = contextData.objects.variant;
  const section = variant.sections[element.section_id];
  const step = variant.steps[section.step_id];

  const scheduler_recommendations = Object.values(
    variant.scheduler_recommendations || {}
  ).filter(
    (recommendation) =>
      recommendation.element_id == element.id &&
      recommendation.toBeDeleted !== true
  );

  return (
    <React.Fragment>
      {element.element_type == "scheduler" && (
        <React.Fragment>
          <SchedulerEmbedSettings
            object={element}
            object_type="elements"
            object_id={element.id}
          />

          <div className="col-xs-12">
            <div className="w-full my-5 relative text-black dark:text-white">
              <span className="text-xl">Conditional Schedulers:</span>

              <Tooltip
                tooltip={`Use conditions to override the default calendar. The first scheduler that meets the conditions is shown; otherwise the default scheduler is used.`}
              />
            </div>

            {scheduler_recommendations.map((scheduler_recommendation) => {
              return (
                <SchedulerRecommendationSettings
                  key={
                    "scheduler-recommendation-" + scheduler_recommendation.id
                  }
                  step={step}
                  section={section}
                  element={element}
                  scheduler_recommendation={scheduler_recommendation}
                />
              );
            })}
          </div>
          <NewSchedulerRecommendation element={element} />
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default ElementSettingsScheduler;
